import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcViews = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8.19 18.268A9.004 9.004 0 0 0 23.296 14.5a8.985 8.985 0 0 0-1.992-3.557C19.696 15.351 15.469 18.5 10.5 18.5c-.792 0-1.564-.08-2.31-.232Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M10.5 8a1.5 1.5 0 0 1-2.242 1.304 2.25 2.25 0 1 0 2.046-2.046c.125.22.196.472.196.742Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M1.852 9.5a9.004 9.004 0 0 1 17.296 0 9.004 9.004 0 0 1-17.296 0Zm12.648 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcViews");

export { IcViews };
//# sourceMappingURL=ic-views.js.map
